"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestMethod = exports.RequestStatus = exports.RequestActionType = void 0;
var RequestActionType;
(function (RequestActionType) {
    RequestActionType["Cancel"] = "CANCEL";
    RequestActionType["Clear"] = "CLEAR";
    RequestActionType["Fail"] = "FAIL";
    RequestActionType["Load"] = "LOAD";
    RequestActionType["Receive"] = "RECEIVE";
    RequestActionType["Update"] = "UPDATE";
})(RequestActionType = exports.RequestActionType || (exports.RequestActionType = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Error"] = "ERROR";
    RequestStatus["Initial"] = "INITIAL";
    RequestStatus["Loaded"] = "LOADED";
    RequestStatus["Updating"] = "UPDATING";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["Create"] = "POST";
    RequestMethod["Delete"] = "DELETE";
    RequestMethod["Receive"] = "GET";
    RequestMethod["Update"] = "PUT";
})(RequestMethod = exports.RequestMethod || (exports.RequestMethod = {}));
